import { useContext } from "react";
import { AvisPrimaryButton } from "../../../buttons";
import { AvisContext } from "../../../../context";
import { IEditableRowState } from "../../types";
interface IActionCancelProps {
  index: number;
  disabled: boolean;
  onStateChange?: (index: number, toState: IEditableRowState) => void;
}
export function ActionCancel(props: Readonly<IActionCancelProps>) {
  const { res } = useContext(AvisContext);
  const { index, disabled, onStateChange } = props;

  return (
    <AvisPrimaryButton
      variant="outlined"
      onClick={() => {
        onStateChange?.(index, "View");
      }}
      label={res("button_Cancel")}
      spacing="small"
      disabled={disabled}
    />
  );
}
